// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yAxu","largestCol":"styles_largestCol__2oG1C","smallestCol":"styles_smallestCol__1X8aJ"};